import { Toast } from '@iveco-ti/iveco-ds'
import { OctagonAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { ToastContentProps } from 'react-toastify'

type ToastNewsMissingFieldsProps = ToastContentProps<{
  onLinkOrFile: () => void
  onContent: () => void
}>

export function ToastNewsMissingFields({
  data,
  closeToast,
}: ToastNewsMissingFieldsProps) {
  const { t } = useTranslation('panel')

  return (
    <Toast.Root color="warning" soft>
      <Toast.Icon icon={<OctagonAlert />} />

      <Toast.Body>
        <Toast.Title title={t('news.use_create_news.toast_schema.title')} />
        <Toast.Description
          description={t('news.use_create_news.toast_schema.description')}
        />

        <Toast.Footer>
          <button
            type="button"
            onClick={() => {
              data?.onLinkOrFile?.()
              closeToast?.()
            }}
            className="text-sm font-semibold text-warning-900 decoration-2 hover:underline focus:underline focus:outline-hidden"
          >
            {t('news.use_create_news.toast_schema.buttons.link_or_attachment')}
          </button>

          <button
            type="button"
            onClick={() => {
              data?.onContent?.()
              closeToast?.()
            }}
            className="text-sm font-semibold text-warning-900 decoration-2 hover:underline focus:underline focus:outline-hidden"
          >
            {t('news.use_create_news.toast_schema.buttons.content')}
          </button>
        </Toast.Footer>
      </Toast.Body>

      <Toast.Close onClick={closeToast} />
    </Toast.Root>
  )
}
